import { render } from "./EmployeeTrainingDetail.vue?vue&type=template&id=1d0bac1c"
import script from "./EmployeeTrainingDetail.vue?vue&type=script&lang=js"
export * from "./EmployeeTrainingDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__